import { ExtendedStepData } from './types'

import { report } from 'utils'

interface ResolveProgressBarStepArgs {
  stepMapping: ReadonlyArray<ExtendedStepData>
  options?: { ignoredPaths: string[] }
}

export const resolveProgressBarSteps = ({ stepMapping, options }: ResolveProgressBarStepArgs) => {
  const pathname = window.location.pathname

  const step = stepMapping.find((step) => step.pathlist.some((path) => pathname.endsWith(path)))

  if (step) {
    return {
      currentPath: step.pathlist.find((path) => pathname.endsWith(path)),
      currentStep: step.id,
    }
  }

  const isPathIgnored = options?.ignoredPaths?.some((path) => pathname.endsWith(path))

  if (isPathIgnored) {
    return
  }

  report(new Error(), "ProgressBar - Current path isn't handled", {
    level: 'warning',
    args: {
      stepMapping,
      pathname: location.pathname,
    },
  })

  return
}
